<template>
  <div
    :class="
      cn(
        'flex px-6 py-4 md:py-6 gap-2 md:gap-3 bg-inherit mt-auto border-t border-secondary',
        {
          'justify-between': showClear,
          'justify-end': !showClear && alignButtons === 'end',
        },
        props.class
      )
    "
  >
    <Button
      v-if="showClear"
      :as="closeOnClear ? DialogClose : undefined"
      :label="$t('components.buttons.clear')"
      variant="primary"
      size="lg"
      :aria-label="$t('components.buttons.clear')"
      class="basis-24"
      @click.stop="$emit('clear')"
    />
    <div
      :class="
        cn('flex max-sm:flex-col-reverse gap-2 md:gap-3', {
          grow: showClear || alignButtons === 'center',
          'justify-end': alignButtons === 'end',
        })
      "
    >
      <Button
        v-if="showCancel"
        :as="closeOnCancel ? DialogClose : undefined"
        :label="cancelLabel || $t('components.buttons.cancel')"
        variant="secondary"
        :type="cancelType"
        size="lg"
        :aria-label="cancelLabel || $t('components.buttons.cancel')"
        :class="{ grow: alignButtons === 'center', 'basis-36': showClear }"
        @click.stop="$emit('cancel')"
      />
      <Button
        v-if="showConfirm"
        :as="closeOnConfirm ? DialogClose : undefined"
        :label="confirmLabel || $t('components.buttons.confirm')"
        variant="primary"
        :type="confirmType"
        size="lg"
        :disabled="disableConfirm"
        :aria-label="confirmLabel || $t('components.buttons.confirm')"
        :class="{ grow: alignButtons === 'center', 'basis-36': showClear }"
        @click.stop="$emit('confirm')"
      />
    </div>
  </div>
</template>

<script setup>
import { Button } from "@/SharedComponents/Buttons";
import { cn } from "@/Utils/cn";

import { DialogClose } from "@/SharedComponents/Dialog";

defineEmits(["cancel", "confirm"]);

const props = defineProps({
  cancelLabel: { type: String, required: false },
  confirmLabel: { type: String, required: false },
  showCancel: { type: Boolean, default: true },
  showConfirm: { type: Boolean, default: true },
  showClear: { type: Boolean, default: false },
  cancelType: { type: String, default: "gray" },
  confirmType: { type: String, required: false },
  class: { type: null, required: false },
  disableConfirm: { type: Boolean, default: false },
  closeOnCancel: { type: Boolean, default: true },
  closeOnConfirm: { type: Boolean, default: true },
  closeOnClear: { type: Boolean, default: true },
  alignButtons: {
    type: String,
    validator: (val) => ["start", "center", "end"].includes(val),
    default: "center",
  },
});
</script>
